import { render, staticRenderFns } from "./NotificationBlock.vue?vue&type=template&id=0183f910"
import script from "./NotificationBlock.vue?vue&type=script&lang=js"
export * from "./NotificationBlock.vue?vue&type=script&lang=js"
import style0 from "./NotificationBlock.vue?vue&type=style&index=0&id=0183f910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports